import React from 'react';
import ImportToggle from './ImportToggle';
import '../css/Imports.css';

/**
 * Seletor de tipos de importação com toggles.
 * Renderiza o toggle mestre "Selecionar Tudo" + toggles individuais (obrigatórios e opcionais).
 *
 * @param {Array}    availableTypes       - [{ value, label }]
 * @param {Array}    selectedTypes        - ['obras', 'cronogramas']
 * @param {Array}    mandatoryTypes       - ['obras']
 * @param {boolean}  disabled             - Se os controles estão desabilitados
 * @param {Function} onToggleType         - Callback(value) ao alternar um tipo
 * @param {Function} onSelectAll          - Callback ao selecionar todos
 * @param {Function} onDeselectOptionals  - Callback ao desselecionar opcionais (mantendo obrigatórios)
 */
const ImportTypeSelector = ({
  availableTypes,
  selectedTypes,
  mandatoryTypes,
  disabled,
  onToggleType,
  onSelectAll,
  onDeselectOptionals
}) => {
  const optionalTypes = availableTypes.filter(t => !mandatoryTypes.includes(t.value));
  const allSelected = selectedTypes.length === availableTypes.length;

  const handleToggleAll = () => {
    if (allSelected) {
      onDeselectOptionals();
    } else {
      onSelectAll();
    }
  };

  return (
    <div className="mb-3">
      <label className="d-block mb-2">
        <strong>Tipos de importação:</strong>
      </label>

      {/* Toggle mestre - Selecionar Tudo */}
      {optionalTypes.length > 0 && (
        <div className="import-type-selector-master">
          <ImportToggle
            id="toggle-select-all"
            checked={allSelected}
            disabled={disabled}
            onChange={handleToggleAll}
            label="Selecionar Tudo"
            layout="inline"
          />
        </div>
      )}

      {/* Tipos: obrigatórios + opcionais */}
      <div className="import-type-selector-row">
        {/* Obrigatórios */}
        {availableTypes.filter(t => mandatoryTypes.includes(t.value)).map(type => (
          <ImportToggle
            key={type.value}
            id={`type-${type.value}`}
            checked={true}
            disabled={true}
            label={type.label}
            sublabel="(obrigatório)"
          />
        ))}

        {/* Opcionais */}
        {optionalTypes.map(type => (
          <ImportToggle
            key={type.value}
            id={`type-${type.value}`}
            checked={selectedTypes.includes(type.value)}
            disabled={disabled}
            onChange={() => onToggleType(type.value)}
            label={type.label}
          />
        ))}
      </div>
    </div>
  );
};

export default ImportTypeSelector;
